/**
 * Duration Input Component
 * Handles rendering of duration inputs for both edit and display modes
 */

import React from "react";
import { CSS_CLASSES, PLACEHOLDERS, COLORS, INLINE_STYLES } from "../utils/cardBodyConstants.js";

/**
 * Duration Input for Edit Mode
 */
export const EditDurationInput = ({
  uFormatedTime,
  uFormatedTimeError,
  timeShowEdit,
  onClick,
  className = "",
}) => {
  return (
    <div
      className={`${CSS_CLASSES.TIMER_SEC_INPUT} ${className}`}
      style={uFormatedTimeError ? INLINE_STYLES.ERROR_BACKGROUND : {}}
      onClick={onClick}
    >
      <input
        className={CSS_CLASSES.EDIT_TIME}
        name="time"
        value={uFormatedTime || ''}
        onChange={(e) => {
          timeShowEdit(e.target.value);
        }}
        placeholder={PLACEHOLDERS.TIME_FORMAT}
        type="text"
        autoComplete="off"
      />
    </div>
  );
};

/**
 * Duration Input for Display Mode
 */
export const DisplayDurationInput = ({
  value,
  onClick,
  className = "",
}) => {
  return (
    <div
      className={`${CSS_CLASSES.TIMER_SEC_INPUT} ${className}`}
      onClick={onClick}
    >
      <input
        style={INLINE_STYLES.CURSOR_POINTER}
        className={CSS_CLASSES.BEFORE_EDIT_INPUT}
        name="time"
        readOnly
        value={value}
        placeholder={PLACEHOLDERS.TIME_FORMAT}
        type="text"
        autoComplete="off"
      />
    </div>
  );
};

/**
 * Default DurationInput Component
 * Compatible with Tracker.jsx usage: { value, onChange, error }
 */
const DurationInput = ({
  value,
  onChange,
  error,
  placeholder = PLACEHOLDERS.TIME_FORMAT,
  className = "",
}) => {
  return (
    <div
      className={`${CSS_CLASSES.TIMER_SEC_INPUT} ${className}`}
      style={error ? INLINE_STYLES.ERROR_BACKGROUND : {}}
    >
      <input
        className={CSS_CLASSES.EDIT_TIME}
        name="time"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        type="text"
        autoComplete="off"
      />
    </div>
  );
};

export default DurationInput;
